// extracted by mini-css-extract-plugin
module.exports = {"titulo":"style_titulo__1W6Z1","frameworkTitleBackground":"style_frameworkTitleBackground__RM_Kr","playlistITemTitle":"style_playlistITemTitle__1MH38"};